(function () {
  var STORAGE_KEY = 'toby_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, ignore */
    }
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function syncButtons(root) {
    var scope = root || document;
    var list = getWishlist();
    var buttons = scope.querySelectorAll('.wishlist-heart-btn');
    buttons.forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      var liked = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-liked', liked);
      btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
      btn.setAttribute('aria-label', liked ? 'Quitar de Mis Me Gusta' : 'Agregar a Mis Me Gusta');
    });
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: currency || 'MXN' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function renderWishlistPage() {
    var container = document.getElementById('wishlist-page-list');
    if (!container) return;

    var emptyState = document.getElementById('wishlist-empty-state');
    var list = getWishlist();

    container.innerHTML = '';

    if (!list.length) {
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;

    var activeCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';

    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .then(function (product) {
          var card = document.createElement('a');
          card.href = '/products/' + product.handle;
          card.className = 'wishlist-card';

          var imgHtml = '';
          if (product.featured_image) {
            imgHtml = '<img src="' + product.featured_image + '" alt="' + (product.title || '') + '" loading="lazy" width="500">';
          }

          var priceHtml = money(product.price, activeCurrency);
          var compareHtml = '';
          if (product.compare_at_price && product.compare_at_price > product.price) {
            compareHtml = '<s class="wishlist-card__compare-price">' + money(product.compare_at_price, activeCurrency) + '</s> ';
          }

          card.innerHTML =
            '<div class="wishlist-card__image">' +
            imgHtml +
            '<button type="button" class="wishlist-heart-btn is-liked" data-wishlist-handle="' +
            product.handle +
            '" aria-pressed="true" aria-label="Quitar de Mis Me Gusta">' +
            '<svg viewBox="0 0 24 24" class="wishlist-heart-icon" aria-hidden="true"><path d="M12 21s-6.7-4.35-9.33-8.2C.92 10.02 1.4 6.5 4.2 4.9c2.2-1.25 4.9-.68 6.4 1.2.5.62.9 1.3 1.4 1.9.5-.6.9-1.28 1.4-1.9 1.5-1.88 4.2-2.45 6.4-1.2 2.8 1.6 3.28 5.12 1.53 7.9C18.7 16.65 12 21 12 21z"/></svg>' +
            '</button></div>' +
            '<div class="wishlist-card__info"><p class="wishlist-card__title">' +
            product.title +
            '</p><p class="wishlist-card__price">' +
            compareHtml +
            priceHtml +
            '</p></div>';

          container.appendChild(card);
        })
        .catch(function () {
          var current = getWishlist();
          var idx = current.indexOf(handle);
          if (idx !== -1) {
            current.splice(idx, 1);
            saveWishlist(current);
          }
        });
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.wishlist-heart-btn');
    if (!btn) return;
    event.preventDefault();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var liked = toggle(handle);
    btn.classList.toggle('is-liked', liked);
    btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    btn.setAttribute('aria-label', liked ? 'Quitar de Mis Me Gusta' : 'Agregar a Mis Me Gusta');
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle: handle, liked: liked } }));
  });

  document.addEventListener('wishlist:change', function (event) {
    var card = event.target && event.target.closest ? event.target.closest('.wishlist-card') : null;
    if (card && document.getElementById('wishlist-page-list')) {
      renderWishlistPage();
    } else if (document.getElementById('wishlist-page-list')) {
      renderWishlistPage();
    }
  });

  function init() {
    syncButtons();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncButtons(event.target || document);
  });
  window.addEventListener('pageshow', function () {
    syncButtons();
  });

  window.TobyWishlist = {
    getWishlist: getWishlist,
    toggle: toggle,
    syncButtons: syncButtons,
  };
})();
